<script>
  import SupplierNavbar from "./SupplierNavbar.svelte";

  export let user;
  export let trueUser;
  export let accountDisplayName;
  export let trueUserDisplayName;

  let logout = function () {
    //@ts-ignore
    window.location = "/users/fully_log_out";
  };
</script>

<header
  class="rep-confirm__header full-width color-white background-brandPrimary"
  data-testid="supplier-navbar"
>
  <div class="fizz-styles padding-top--smaller padding-bottom--smaller">
    <SupplierNavbar {logout} {user} {trueUserDisplayName} {accountDisplayName} {trueUser} />
  </div>
</header>
